import React, { useCallback, useEffect, useState } from 'react'
import { useGlobalStyles } from '~shared/styles/globalStyles'
import { useAutocompleteName } from '~utils/autocompleteType'
import { useTranslation } from 'react-i18next'
import { CourseRegistrationFormPrefills, useSalutationOptions } from '~api/models'
import Row from '~shared/components/MuiGrid/Row'
import Col from '~shared/components/MuiGrid/Col'
import { Box, CircularProgress, Divider, Typography } from '@mui/material'
import FormAutocompleteRedesign from '~shared/components/reactHookForm/input/FormAutocomplete/FormAutocompleteRedesign'
import { KeyboardArrowDownRounded } from '@mui/icons-material'
import FormTextFieldNew from '~shared/components/reactHookForm/input/FormTextFieldRedesign'
import { Step1ContactDetailsForm } from '@saf/saf-kundenportal-frontend-api/models/Step1ContactDetailsForm'
import { useSelector } from 'react-redux'
import { getUser } from '~store/account/selectors'
import { AsyncModel } from '~shared/models/AsyncModel'
import { CourseApi } from '~api/instances'
import CircularProgressButton from '~shared/components/ProgressButton/CircularProgressButton'
import clsx from 'clsx'

const Step1ContactDetails: React.FC = () => {
  const gs = useGlobalStyles()
  const acName = useAutocompleteName<Step1ContactDetailsForm>()
  const { t } = useTranslation()
  const salutationOptions = useSalutationOptions()
  const user = useSelector(getUser)
  const [coursePrefills, setCoursePrefills] = useState<AsyncModel<CourseRegistrationFormPrefills>>({})
  const fetchRegisterCoursePrefills = useCallback(() => {
    setCoursePrefills({ ...coursePrefills, inProgress: true })
    CourseApi.getRegisterCoursePrefills()
      .then((data) => {
        setCoursePrefills({ ...coursePrefills, payload: data, error: undefined, inProgress: false })
      })
      .catch((data) => {
        setCoursePrefills({ ...coursePrefills, error: data, inProgress: false })
      })
  }, [coursePrefills])

  useEffect(() => {
    fetchRegisterCoursePrefills()
    // eslint-disable-next-line -- on mount
  }, [])

  return <>
    <Row className={gs.gridTopMarginFix}>
      <Col xs={12}>
        <Box fontStyle='italic'>
          <Typography variant='h4' component='h2'>
            {t('common:headSpareAxleRequest')}
          </Typography>
          <Divider className={gs.marginBottomTiny} variant='fullWidth' style={{ maxWidth: '125px', backgroundColor: '#000' }} />
          <Typography variant='h5' component='h4' className={gs.marginBottomTiny} color='secondary'>
            {t('common:step1contactDetails')}
          </Typography>
        </Box>
      </Col>
    </Row>
    {
      coursePrefills.inProgress
      && <CircularProgress color='primary' />
    }
    {
      coursePrefills.payload
      && <><Row>
        <Col xs={3}>
          <FormAutocompleteRedesign
            label={t('common:salutation')}
            name={acName('salutation')}
            defaultValue={user?.salutation}
            options={salutationOptions}
            popupIcon={<KeyboardArrowDownRounded />}
            fullWidth
          />
        </Col>
      </Row>
      <Row>
          <Col xs={3}>
          <FormTextFieldNew
              label={t('common:firstName')}
              name={acName('firstname')}
              defaultValue={user?.firstName}
            />
        </Col>
          <Col xs={3}>
          <FormTextFieldNew
              label={t('common:surname')}
              name={acName('lastname')}
              defaultValue={user?.lastName}
            />
        </Col>
        </Row>
      <Row>
          <Col xs={3}>
          <FormTextFieldNew
              label={t('common:companyName')}
              name={acName('company')}
              defaultValue={coursePrefills.payload?.companyName}
            />
        </Col>
        </Row>
      <Row>
          <Col xs={3}>
          <FormTextFieldNew
              label={t('common:streetAndNumber')}
              name={acName('streetAndNumber')}
              defaultValue={coursePrefills.payload?.streetAndNumber}
            />
        </Col>
          <Col xs={1}>
          <FormTextFieldNew
              label={t('common:zip')}
              name={acName('zip')}
              defaultValue={coursePrefills.payload?.zip}
            />
        </Col>
          <Col xs={2}>
          <FormTextFieldNew
              label={t('common:city')}
              name={acName('city')}
              defaultValue={coursePrefills.payload?.city}
            />
        </Col>
        </Row>
      <Row>
          <Col xs={3}>
          <FormTextFieldNew
              label={t('common:eMail')}
              name={acName('email')}
              defaultValue={user?.email}
            />
        </Col>
        </Row>
      <Row>
          <Col xs={3}>
          <FormTextFieldNew
              label={t('common:phone')}
              name={acName('phone')}
              defaultValue={coursePrefills.payload?.phone}
            />
        </Col>
        </Row>
      </>
    }
    {
      coursePrefills.error
      && <>
        <Typography>
          Beim Abrufen der Formular-Daten ist ein Fehler aufgetreten. Bitte versuchen sie es zu einem späteren Zeitpunkt erneut.
        </Typography>
        <CircularProgressButton
          variant='contained'
          size='small'
          color='secondary'
          type='submit'
          onClick={fetchRegisterCoursePrefills}
          disabled={coursePrefills.inProgress}
          disableElevation
          className={clsx(gs.marginTopSmall, gs.marginBottomSmall)}
          text={t('common:tryAgain')}
        />
      </>
    }
  </>
}

export default Step1ContactDetails
